import { mirrorEasing } from './modifiers/mirror.mjs';
import { reverseEasing } from './modifiers/reverse.mjs';
var easeIn = function easeIn(p) {
  return p * p;
};
var easeOut = reverseEasing(easeIn);
var easeInOut = mirrorEasing(easeIn);
export { easeIn, easeInOut, easeOut };